import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { featureTogglesRoutePerm } from 'components/Routes/routePermissions';
import { UserCapabilityName } from 'types/userCapabilityName';
import PageRoute from '../../components/Routes/PageRoute';

const FeatureToggles = lazy(
  () =>
    import(/* webpackChunkName: "feature-toggles-page" */ './FeatureToggles')
);

const FeatureToggleEdit = lazy(
  () =>
    import(
      /* webpackChunkName: "feature-toggle-edit-page" */ './FeatureToggleEdit'
    )
);

const FeatureToggleCreate = lazy(
  () =>
    import(
      /* webpackChunkName: "feature-toggle-create-page" */ './FeatureToggleCreate'
    )
);

const { userCapabilities } = featureTogglesRoutePerm;

export const featureTogglesRoutes = (
  <Route path="feature-toggles/*">
    <Route
      path=""
      element={
        <PageRoute
          userCapabilities={userCapabilities}
          pageInfo={{ title: 'Feature Toggles' }}
        >
          <FeatureToggles />
        </PageRoute>
      }
    />
    <Route
      path="edit/:toggleId"
      element={
        <PageRoute
          userCapabilities={[UserCapabilityName.FeatureToggleAdmin]}
          pageInfo={{ title: 'Edit Toggle' }}
        >
          <FeatureToggleEdit />
        </PageRoute>
      }
    />
    <Route
      path="create"
      element={
        <PageRoute
          userCapabilities={[UserCapabilityName.FeatureToggleAdmin]}
          pageInfo={{ title: 'Create Toggle' }}
        >
          <FeatureToggleCreate />
        </PageRoute>
      }
    />
    <Route path="*" element={<Navigate to="/404" />} />
  </Route>
);
